<template>
  <v-footer
    app
    class="primary"
    absolute
    fill-height
  >
    <v-row class="flex-column flex-lg-row flex-xl-row">
      <v-col class="center order-0">
        <v-btn
          text
          fab
          color="white"
          href="https://www.facebook.com/DivetosVeterinarija"
          target="_blank"
        >
          <v-icon large>
            fa-facebook-square
          </v-icon>
        </v-btn>
        <v-btn
          text
          fab
          color="white"
          href="https://www.instagram.com/divet_veterinarija/"
          target="_blank"
        >
          <v-icon large>
            fa-instagram
          </v-icon>
        </v-btn>
      </v-col>
      <v-col class="center order-2 order-lg-1 oder-xl-1">
        <span class="white--text">DiVet © {{ new Date().getFullYear() }}</span>
      </v-col>
      <v-col class="center order-1 order-lg-2 oder-xl-2">
        <span class="white--text">
          <span class="font-weight-bold">Tel. nr.: </span>
          <span class="font-weight-light">{{ telefonoNumeris }}</span>
        </span>
        <br>
        <span class="white--text">
          <span class="font-weight-bold">Adresas: </span>
          <span class="font-weight-light">{{ adresas }}</span>
        </span>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
export default {
  name: "AppFooter",
  props: {
    adresas: {
      type: String,
      default: ""
    },
    telefonoNumeris: {
      type: String,
      default: ""
    }
  }
};
</script>
<style scoped>
.center {
  text-align: center;
  align-self: center;
}
</style>
